export default __webpack_public_path__ + "static/artifakt-legend-light-81da8d41a9467c5eddab66a77847fb5d.ttf";